import type { TOC } from '@ember/component/template-only';

import ClientsGoalsComponent from 'webapp/components/clients/goals';
import NoResultsClientsPerformanceComponent from 'webapp/components/no-results/clients-performance';
import type ClientsGoalsController from 'webapp/controllers/clients/goals';

interface Args {
	controller: ClientsGoalsController;
}

const ClientsGoalsRouteTemplate: TOC<Args> = <template>
	{{#if @controller.clients}}

		<ClientsGoalsComponent
			@clients={{@controller.clients}}
			@onAdd={{@controller.createNewClient}}
		/>

	{{else}}

		<NoResultsClientsPerformanceComponent @onCreate={{@controller.createNewClient}} />

	{{/if}}
</template>;

export default ClientsGoalsRouteTemplate;
